import { render } from "./PdfDBLinks.vue?vue&type=template&id=8c00ce94"
import script from "./PdfDBLinks.vue?vue&type=script&lang=js"
export * from "./PdfDBLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__